import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class PartiesService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    getPartyContactMechanisms(id: number, category?: string): Observable<any> {
        return this.post<any>(EndPoints.parties_getPartyContactMechanisms, false, '', {
            id: id,
            category: category
        });
    }
}
